<div
    class="spot-grid__row"
    *ngFor="let row of rows"
    [attr.id]="row.id"
    [ngClass]="row.classNames"
    [style.backgroundColor]="row.color"
>
    <app-spot-renderer *ngFor="let spot of row.spots" [spot]="spot"></app-spot-renderer>
</div>
